import React from 'react';

import { EmbedContainer } from './styles';

const RichTextEmbed = ({ fields, ...otherProps }) => {
  const code = fields?.embedCode || fields?.headCode;

  const embededCode = code && code['en-US']?.content[0]?.content[0]?.value;

  return (
    <EmbedContainer
      {...otherProps}
      dangerouslySetInnerHTML={{ __html: embededCode }}
      className="rich-text-embed"
    />
  );
};

export default RichTextEmbed;
